import React from 'react';
import { useConsent } from '@/contexts/ConsentContext';
import ConsentBanner from './ConsentBanner';
import ConsentModal from './ConsentModal';

/**
 * Renders the consent banner and modal.
 * Separated from ConsentProvider to avoid a circular import
 * (ConsentContext ↔ ConsentBanner/ConsentModal both import each other).
 * Must be rendered inside <ConsentProvider>.
 */
const ConsentUI: React.FC = () => {
  const { showBanner, showModal } = useConsent();

  return (
    <>
      {showBanner && <ConsentBanner />}
      {showModal && <ConsentModal />}
    </>
  );
};

export default ConsentUI;
